import toast from "src/swsh-native/toast";
import getRandomString from "src/helpers/getRandomString";
import { getAssetPersist } from "../stores/useAssetPersist";
import { RemoteDownloadAssetInfo } from "../types";
import requestSaveLibraryPermissions from "./helpers/requestSaveLibraryPermissions";

const queueDownload = async (input: RemoteDownloadAssetInfo[]) => {
	const { granted } = await requestSaveLibraryPermissions();
	if (!granted) {
		toast({
			preset: "error",
			title: "Missing permissions",
			message: "You need to grant permissions to save images to your library.",
		});
		return;
	}

	const { pushDownloadAssets } = getAssetPersist();

	pushDownloadAssets(
		input.map((image) => ({
			...image,
			assetId: getRandomString(),
			didFail: false,
			isDownloading: false,
		})),
	);
};
export default queueDownload;
